module.exports = __webpack_public_path__ + "img/collect.5afe466d.svg";